import React, { useState } from 'react';
import { InputAdornment, IconButton } from '@material-ui/core';
import { useTypedTranslation } from '@app/hooks';
import { TranslationsTypes } from '@app/models';
import { PasslyTextField } from '@app/components';

interface IProps {
    value: string;
    onChange: Function;
    allowReveal?: boolean | false;
    previousPassword?: string;
    disabled?: boolean;
    label?: TranslationsTypes;
}

export function PasslyValidatedPassword(props: IProps) {
    const [isMasked, setIsMasked] = useState(true);

    const { value, disabled, onChange, label } = props;

    const { translation } = useTypedTranslation();

    return (
        <PasslyTextField
            fullWidth
            label={translation(label ? label : 'PASSWORD')}
            autoComplete='confirm-password'
            value={value}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event)}
            id='passlyValidatedPassword'
            name='confirmPassword'
            type={props.allowReveal && !isMasked ? 'text' : 'password'}
            required
            disabled={disabled}
            autoFocus
            InputProps={{
                endAdornment: (
                    <>
                        {props.allowReveal && (
                            <InputAdornment position='end'>
                                <IconButton size='small' onClick={() => setIsMasked(!isMasked)}>
                                    {isMasked ? (
                                        <i className='fa-regular fa-eye' style={{ width: '22.5px' }} />
                                    ) : (
                                        <i className='fa-regular fa-eye-slash' />
                                    )}
                                </IconButton>
                            </InputAdornment>
                        )}
                    </>
                )
            }}
        />
    );
}
